/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-31 10:30:08
 */

import * as request from '@/utils/request'

export default {
  /**
   * getTaskList
   * @description 批次任务列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getTaskList(data) {
    return request.post('/task/list', data)
  },
  getTaskMissionList(data) {
    return request.post('/task_mission/list', data)
  },
  cancelMissionTask(data){
    return request.post('/task_mission/cancel', data)
  },
  getTaskMissionInfo(data) {
    return request.post('/task_mission/get_info', data)
  },
  getTaskMissionDetail(data) {
    return request.post('/task_mission/get_detail', data)
  },
  saveTaskMissionSettlement(data) {
    return request.post('/task_mission/save_settlement', data)
  },
  /**
   * saveTask
   * @description 保存批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveTask(data) {
    return request.post('/task/store', data)
  },
  getTaxbasisTask(data) {
    return request.post('/task/check_tax_fee', data)
  },
  /**
   * getTaskInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  // getTaskInfo(id) {
  //   let data = {id:id}
  //   return request.post('/task/get_info', data)
  // },
    getTaskInfo(data) {
      return request.post('/task/get_info', data)
    },
  /**
   * deleteTask
   * @description 删除批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteTask(id) {
    let data = {id:id}
    return request.post('/task/delete', data)
  },
  /**
   * saveTask
   * @description 提交批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  sendTask(data) {
    return request.post('/task/send', data)
  },
  /**
   * sendDailyTask
   * @description 提交日结批次任务
   * @author Cursor
   * @date 2026-03-25
   * @param {*} data
   * @returns
   */
  sendDailyTask(data) {
    return request.post('/task/daily_send', data)
  },
  /**
   * cancelTask
   * @description 作废批次任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  cancelTask(data) {
    return request.post('/task/change_status', data)
  },
  /**
   * @description 获取分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getTaskCategoryList() {
    return request.post('/task/category_list')
  },
   // 京翎获取开票类目
   getJinglingCategoryList(){
    return request.post('/task/jl_get_invoice_type')
  },
  // 
  getJinglingTaskList(data){
    return request.post('/task/jl_get_invoice_task',data)
  },
  /**
   * getTaskSign
   * @description 获取签约情况
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getTaskSign(data) {
    return  request.post('/customer/check_sign', data)
  },
  getTaskSigns(data) {
    return  request.post('/customer/check_signs', data)
  },
  // 计算劳务费
  postCheckLaborFee(data){
    return request.post('/task/check_labor_fee',data)
  },
  // 银行卡是否认证
  getCardIsAuth(data) {
    return  request.post('/customer/check_cards', data)
  },
}